import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { isAuthTokenValid } from './utils';
import { useNavigate, useParams } from 'react-router-dom';
import './invoiceRenderer.css';

const InvoiceRenderer = () => {
    const [invoice, setInvoice] = useState(null);
    const [patientName, setPatientName] = useState('');
    const [patientID,setPatientID] = useState('');
    const orgID = '837447409';
    const serverURL = process.env.REACT_APP_SERVER_BASE_URL;
    const navigate = useNavigate();
    const {invoiceId} = useParams();
    useEffect(() => {
        const fetchInvoice = async () => {
            const accessToken = localStorage.getItem('access_token');
            if (!isAuthTokenValid()) {
                navigate('/authentication');
                return;
              }
            try {
                const response = await axios.get(serverURL+`/getInvoice`, {
                  params: {
                    organization_id: orgID,
                    invoice_id: invoiceId,
                  },
                  headers: {
                      Authorization: 'Zoho-oauthtoken '  + accessToken,
                  },
                });
                if (response.status >= 200 && response.status < 300) {
                  const responseData = response.data;
                  const thisInvoice = responseData.response.invoice
                  let thisPatientID = '';
                  let thisPatientName = '';
                  const savedName = await fetchSavedName(invoiceId);

                  if(!savedName.patient_id) {
                    const customFields = thisInvoice.custom_fields;
                    const patientNameField = customFields.find((field) => field.label === 'Patient Name');
                    const patientIDField = customFields.find((field) => field.label === 'Patient ID');
                    thisPatientID = patientIDField ? patientIDField.value : ''; // Check if patientIDField exists
                    thisPatientName = patientNameField.value;
                  } else {
                    thisPatientName = savedName.patient_name;
                    thisPatientID = savedName.patient_id;
                  }
                  
                  if (thisPatientID && !thisPatientID.includes('ID')) {
                      thisPatientID = 'ID-' + thisPatientID;
                  }

                  setInvoice(thisInvoice);
                  setPatientID(thisPatientID);
                  setPatientName(thisPatientName);
                  
                
                } else {
                  console.error('API error:', response.status, response.statusText);
                }
              } catch (error) {
                console.error('Error fetching invoice details:', error);
              }
        };
        const fetchSavedName = async (invoiceId) => {
            try {
                const response = await axios.get(serverURL + `/sh_invoice-patient/${invoiceId}`);
                if(response.status === 200) {
                    let savedName = {};
                    if(response.data) {
                        const invoice = response.data; // Assuming response data is an array of invoices
                        const { patient_name, patient_id } = invoice;
                        savedName = { patient_name:patient_name, patient_id: patient_id }; 
                    }
                    console.log(savedName);
                    return savedName;
                } else {
                    console.error('API error:', response.status, response.data);
                    return {};
                }
        
            } catch(error) {
                console.error('Error fetching saved name:', error);
                return {};
            }
        };
        fetchInvoice();
    }, [invoiceId]);

    if (!invoice) {
        return <div>Loading...</div>;
    }
    const handlePrint = () => {
        window.print();
    };

    const handleClose = () => {
        window.close();
    };
    
    return (
        <div className='printArea'>
            <div className="top-section">
                <div className="left-section">
                    <div className="left-top-section">
                        <div className="logo-placeholder">
                            <img src='https://books.zoho.com/ZFInvoiceLogo.zbfs?logo_id=94b1f974467635c851a3966a84dd3eb8' alt="Logo" />
                        </div>
                        <p style={{ fontSize: '10pt', color: '#333333' }}><b>Shuman Hospital</b></p>
                        <p style={{ fontSize: '9pt' }}>Freetown, Sierra Leone</p>
                        <p style={{ fontSize: '9pt' }}>billing@shumanhospital.com</p>
                        <br />
                    </div>
                    <div className="left-bottom-section">
                        <p style={{ fontSize: '10pt', fontWeight: 400 }}>Bill To</p>
                        <p style={{ fontSize: '9pt' }}><b>{invoice.customer_name}</b></p>
                        <p style={{ fontSize: '9pt' }}></p>
                    </div>
                </div>
                <div className="right-section">
                    <div className="invoice-title">Invoice</div>
                    <div className="invoice-details">
                        <p># {invoice.invoice_number}</p>
                        <p></p>
                        <p style={{fontSize: '8pt'}}>Balance Due:</p>
               
                        <p style={{fontSize: '12pt'}}><strong>SLL{invoice.total}</strong></p>
                    </div>
                    <table className="invoice-table2">
                        <tr>    
                            <td style={{ width: '20%' }}></td>
                            <td>Invoice Date:</td>
                            <td>{invoice.date}</td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%' }}></td>
                            <td>Terms:</td>
                            <td>{invoice.payment_terms_label}</td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%' }}></td>
                            <td>Due Date:</td>
                            <td>{invoice.due_date}</td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%' }}></td>
                            <td>Patient Name:</td>
                            <td>{patientName}</td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%' }}></td>
                            <td>Patient ID:</td>
                            <td>{patientID}</td>
                        </tr>
                    </table>
                   </div>
            </div>

            <table className='tableItems'>
                <thead>
                <tr > 
                    <th className="itemsHeader" >#</th>
                    <th className="itemsHeader">Item & Description</th>
                    <th className="itemsHeader">Qty</th>
                    <th className="itemsHeader">Rate</th>
                    <th className="itemsHeader">Amount</th>
                </tr>
                </thead>
                <tbody>
                {invoice.line_items.map((item) => (
                <tr key={item.line_item_id}>
                    <td>{item.item_order}</td>
                    <td>{item.name}</td>
                    <td>{item.quantity} {item.unit}</td>
                    <td>{item.rate}</td>
                    <td>{item.item_total}</td>
                </tr>

                ))}
                </tbody>
            </table>


            <div className="footer">
                <div className="footer-left">
                    <div style={{ whiteSpace: 'pre-wrap' }}></div>
                </div>
                <div className="footer-right">
                    <table className="pcs-totals" cellSpacing="0" border="0">
                        <tbody>
                            <tr>
                            <td>
                                Sub Total <br />
                                <span className="subtotal-label">Tax Inclusive</span>
                            </td>
                            <td>{invoice.sub_total}</td>
                            </tr>
                            <tr>
                            <td style={{ textAlign: 'right' }}><b>Total</b></td>
                            <td style={{ textAlign: 'right' }}><b>SLL{invoice.total}</b></td>
                            </tr>
                            <tr className="pcs-balance">
                            <td style={{ textAlign: 'right' }}><b>Balance Due</b></td>
                            <td style={{ textAlign: 'right' }}><b>SLL{invoice.balance}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{ clear: 'both' }}></div>   
            </div>
    
            <div className="notes">
                <strong>Notes:</strong>
                <p>{invoice.notes}</p>
            </div>
            <div className="buttons">
                <button onClick={handlePrint}>Print</button>
                <button onClick={handleClose}>Close</button>
            </div>
        </div>
    );
};

export default InvoiceRenderer;
